import { render, staticRenderFns } from "./ImportExportCadastroDB.vue?vue&type=template&id=2fff790c"
import script from "./ImportExportCadastroDB.vue?vue&type=script&lang=js"
export * from "./ImportExportCadastroDB.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports